export default class CommonFile {
    /**
     * @type {string}
     * @memberof CommonFile
     * @name 类型
     */
    public contentType: string;
    /**
     * @type {string}
     * @memberof CommonFile
     * @name 地址
     */
    public fileUrl: string;
    /**
     * @type {string}
     * @memberof CommonFile
     * @name ID
     */
    public uid: string;
    /**
     * @type {string}
     * @memberof CommonFile
     * @name 名称
     */
    public name: string;
    /**
     * @type {boolean}
     * @memberof CommonFile
     * @name 是否为第一次上传
     */
    public newUploadFlag: boolean;
    /**
     * @type {number}
     * @memberof CommonFile
     * @name 大小
     */
    public size: number;
    /**
     * @type {string}
     * @memberof CommonFile
     * @name url
     */
    public url: string;
    constructor({
        contentType = '',
        fileUrl = '',
        url = '',
        uid = '',
        name = '',
        newUploadFlag = false,
        size = 0
    } = {}) {
        this.contentType = contentType;
        this.fileUrl = fileUrl;
        this.url = fileUrl;
        this.uid = uid;
        this.name = name;
        this.newUploadFlag = newUploadFlag;
        this.size = size
    }
}